// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gLUFHp{
    display: none !important;
}

.SfxModalTitle-LabelPrimary{
    text-align: center;
}

@media (max-width: 775px) {
    .FIE_topToolsWrapper {
      flex-direction: column-reverse !important;
    }

    .FIE_tabsWrapper {
      order: 1 !important;
      flex-direction: row !important;
      justify-content: space-around;
      padding: 8px 0;
      border-top: 1px solid #ccc;
      background-color: #f9f9f9;
    }

    .FIE_mainToolsWrapper {
      order: 2;
    }
  }

  @media (min-width: 310px) and (max-width: 775px) {
    /* Move the drawer to bottom */
    .FIE_tabs-drawer {
        transform: none !important;           /* cancel any slide-out animation */
        visibility: visible !important;       /* force it visible */
        opacity: 1 !important;
        pointer-events: auto !important;
        position: absolute !important;
        bottom: 0 !important;
        top: auto !important;
        left: 0 !important;
        right: 0 !important;
        width: 100% !important;
        height: auto !important;
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-around;
        padding: 0;
        background: #fff;
        z-index: 1000;
        border-top: 1px solid #ddd;
      }

      /* Prevent overlap with content */
      .FIE_editorWrapper {
        padding-bottom: 60px !important;
      }

      /* Optional: hide the drawer toggle button if needed */
      .FIE_tabs-toggle {
        display: none !important;
      }

    .SfxDrawer-list{
        display: flex;
        margin:0px;
        padding:0px;
        height:40px;
        justify-self:center;
    }
    .FIE_tabs_toggle_btn{
        display: none !important;
    }
    .SfxDrawer-header{
        display: none !important;
    }
    .FIE_editor-content{
        /* height: 450px!important; */
        height: calc(100% - 80px)!important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/Memory_journal/editor.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;MACE,yCAAyC;IAC3C;;IAEA;MACE,mBAAmB;MACnB,8BAA8B;MAC9B,6BAA6B;MAC7B,cAAc;MACd,0BAA0B;MAC1B,yBAAyB;IAC3B;;IAEA;MACE,QAAQ;IACV;EACF;;EAEA;IACE,8BAA8B;IAC9B;QACI,0BAA0B,YAAY,mCAAmC;QACzE,8BAA8B,QAAQ,qBAAqB;QAC3D,qBAAqB;QACrB,+BAA+B;QAC/B,6BAA6B;QAC7B,oBAAoB;QACpB,oBAAoB;QACpB,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,uBAAuB;QACvB,wBAAwB;QACxB,8BAA8B;QAC9B,6BAA6B;QAC7B,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,0BAA0B;MAC5B;;MAEA,iCAAiC;MACjC;QACE,+BAA+B;MACjC;;MAEA,sDAAsD;MACtD;QACE,wBAAwB;MAC1B;;IAEF;QACI,aAAa;QACb,UAAU;QACV,WAAW;QACX,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,6BAA6B;QAC7B,mCAAmC;IACvC;EACF","sourcesContent":[".gLUFHp{\n    display: none !important;\n}\n\n.SfxModalTitle-LabelPrimary{\n    text-align: center;\n}\n\n@media (max-width: 775px) {\n    .FIE_topToolsWrapper {\n      flex-direction: column-reverse !important;\n    }\n\n    .FIE_tabsWrapper {\n      order: 1 !important;\n      flex-direction: row !important;\n      justify-content: space-around;\n      padding: 8px 0;\n      border-top: 1px solid #ccc;\n      background-color: #f9f9f9;\n    }\n\n    .FIE_mainToolsWrapper {\n      order: 2;\n    }\n  }\n\n  @media (min-width: 310px) and (max-width: 775px) {\n    /* Move the drawer to bottom */\n    .FIE_tabs-drawer {\n        transform: none !important;           /* cancel any slide-out animation */\n        visibility: visible !important;       /* force it visible */\n        opacity: 1 !important;\n        pointer-events: auto !important;\n        position: absolute !important;\n        bottom: 0 !important;\n        top: auto !important;\n        left: 0 !important;\n        right: 0 !important;\n        width: 100% !important;\n        height: auto !important;\n        display: flex !important;\n        flex-direction: row !important;\n        justify-content: space-around;\n        padding: 0;\n        background: #fff;\n        z-index: 1000;\n        border-top: 1px solid #ddd;\n      }\n\n      /* Prevent overlap with content */\n      .FIE_editorWrapper {\n        padding-bottom: 60px !important;\n      }\n\n      /* Optional: hide the drawer toggle button if needed */\n      .FIE_tabs-toggle {\n        display: none !important;\n      }\n\n    .SfxDrawer-list{\n        display: flex;\n        margin:0px;\n        padding:0px;\n        height:40px;\n        justify-self:center;\n    }\n    .FIE_tabs_toggle_btn{\n        display: none !important;\n    }\n    .SfxDrawer-header{\n        display: none !important;\n    }\n    .FIE_editor-content{\n        /* height: 450px!important; */\n        height: calc(100% - 80px)!important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
